import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const randomColor = require('randomcolor');

let color = randomColor({
  count: 10000,
  hue: 'random',
  luminosity: 'light',
});

const VendorGraphic = ({ vendorsArr }) => {
  const { t } = useTranslation();
  let state;
  state = {
    dataDoughnut: {
      labels: vendorsArr.name,
      datasets: [
        {
          data: vendorsArr.value,
          backgroundColor: color,
        },
      ],
    },
    options: {
      tooltips: {
        enabled: true,
        callbacks: {
          beforeLabel: function (tooltipItem, data) {
            return data.labels[tooltipItem.index];
          },
          label: function (tooltipItem, data) {
            let value = data.datasets[0].data[tooltipItem.index];
            if (parseInt(value) >= 1) {
              return value.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              });
            }
          },
        },
      },
      legend: {
        display: false,
      },
      maintainAspectRatio: true,
      title: {
        display: true,
        text: t('label:company'),
      },
      responsive: true,
    },
  };

  return (
    <Doughnut data={state.dataDoughnut} options={state.options} width={100} />
  );
};

export default VendorGraphic;
